import {PollInfoRecord} from './common.model';

export class BtPoll extends PollInfoRecord {
// 24 fields

    prsnId: number;
    publishedFlag: boolean;
    scriptRequiredFlag: boolean;

    init(): BtPoll {

        this.prsnId = 0;
        this.publishedFlag = false;
        this.scriptRequiredFlag = false;  // FUTURE:allow 'ALL' and 'S' script; false is default value

        this.pollId = 0;
        this.pollTitle = '';
        this.preText = '';
        this.postText = '';
        this.topgifUrl = '';
        this.endpollUrl = '';
        this.customPollUrl = '';
        this.styleSheetUrl = '';

        this.questSetNums = 0;   // number of quest sets for particular pollId and scriptId.

        this.timeLimit = null;

        this.anonymity = 1;     // default value is 'Responses are anonymous to other poll takers'

        this.resultsAvailableFlag = false;         // taker can see poll results
        this.mustAnswerAllFlag = false;            // taker must answer all questions
        this.multipleResponsesFlag = false;        // taker can take poll more than one time
        this.selfTestFlag = false;                 // means taker can see answers after poll submission
        this.pollResponseEditableFlag = false;     // taker can redo poll by updating its responses
        this.hasCorrectAnswersFlag = false;        // poll has correct answers
        this.previewResponsesFlag = false;         // poll taker submits responses in preview page

        this.openDate = '';                        // date string
        this.closeDate = '';                       // date string
        this.resultsDate = '';                     // date string

        this.themeTypeCode = '';                   // theme type attached to poll

        this.ownerAuthorRole = false;              // Poll Owner has "AUTHOR" role

        return this;
    }

    static deserialize(json: any): BtPoll {
        let model: BtPoll = null;
        if (json) {
            model = Object.assign(new BtPoll(), json);
        }
        return model;
    }

}

export class Question {

    questNum: number;
    questTypeCode: string;
    questLabel: string;
    preText: string;
    postText: string;
    text: string;
    shortTextLimit: number;
    scaleMaxValue: number;
    choicesCount: number;  // TBD: do not use
    choicesColumnWidth: number;
    choicesLayoutTypeCode: string;
    choicesLabelTypeCode: string;
    mustAnswerFlag: boolean;
    otherResponseFlag: boolean;
    otherResponseTextLimit: number;
    otherResponseColumnWidth: number;
    subquestCount: number; // TBD: do not use
    subquestLabelTypeCode: string;
    subquestColumnWidth: number;
    initialValue: string;

    /**
     *  Initialize with default values
     */
    init() {
        this.questNum = 0;
        this.questTypeCode = 'ST';
        this.questLabel = '';
        this.preText = '';
        this.postText = '';
        this.text = '';
        this.shortTextLimit = 250;
        this.scaleMaxValue = 10;
        this.choicesCount = 0;
        this.choicesColumnWidth = 50;
        this.choicesLayoutTypeCode = '1';
        this.choicesLabelTypeCode = 'A';
        this.mustAnswerFlag = false;
        this.otherResponseFlag = false;
        this.otherResponseTextLimit = 250;
        this.otherResponseColumnWidth = 50;
        this.subquestCount = 0;
        this.subquestLabelTypeCode = 'A';
        this.subquestColumnWidth = 50;
        this.initialValue = '';

        return this;

    }

    static deserialize(model: Question, json: any): Question {
        if (json) {
            model.questNum = json.questNum;
            model.questTypeCode = json.questTypeCode || '';
            model.questLabel = json.questLabel || '';
            model.preText = json.preText || '';
            model.postText = json.postText || '';
            model.text = json.text || '';
            model.shortTextLimit = json.shortTextLimit;
            model.scaleMaxValue = json.scaleMaxValue;
            model.choicesCount = json.choicesCount;
            model.choicesColumnWidth = json.choicesColumnWidth;
            model.choicesLayoutTypeCode = json.choicesLayoutTypeCode || '';
            model.choicesLabelTypeCode = json.choicesLabelTypeCode || '';
            model.mustAnswerFlag = json.mustAnswerFlag || false;
            model.otherResponseFlag = json.otherResponseFlag || false;
            model.otherResponseTextLimit = json.otherResponseTextLimit;
            model.otherResponseColumnWidth = json.otherResponseColumnWidth;
            model.subquestCount = json.subquestCount;
            model.subquestLabelTypeCode = json.subquestLabelTypeCode || '';
            model.subquestColumnWidth = json.subquestColumnWidth;
            model.initialValue = json.initialValue;
        }
        return model;
    }

}

export class QuestionExt extends Question {

    answers: CorrectAnswer[];
    multiChoices: MultiChoice[]; // ordered by questNum and choiceNum
    subquestions: Subquestion[]; // ordered by questNum and subquestNum

    init() {
        super.init();
        this.answers = [];
        this.multiChoices = [];
        this.subquestions = [];
        return this;
    }

    static deserialize(json: any): QuestionExt {
        let model: QuestionExt = null;
        if (json) {
            model = new QuestionExt();

            Question.deserialize(model, json);

            if (json.answers) {
                model.answers = json.answers;
            }

            if (json.multiChoices) {
                model.multiChoices = json.multiChoices;
            }

            if (json.subquestions) {
                model.subquestions = json.subquestions;
            }

        }
        return model;
    }
}

export class Questions extends Array<QuestionExt> {

    static deserialize(json: any): Questions {
        let model: Questions = null;
        if (json) {
            model = Object.assign(new Questions(), json);
        }
        return model;
    }


}

export class ScriptQuestSet {
    scriptId: number;
    questSetNum: number;
    questSetDesc: string;


    constructor(scriptId?: number, questSetNum?: number, questSetDesc?: string) {
        this.scriptId = scriptId;
        this.questSetNum = questSetNum;
        this.questSetDesc = questSetDesc;
    }
}

export class ScriptQuestSets extends Array<ScriptQuestSet> {

    static deserialize(json: any): ScriptQuestSets {
        let model = null;
        if (json) {
            model = Object.assign(new ScriptQuestSets(), json);
        }
        return model;
    }
}

export class Script {
    scriptId: number;
    scriptTypeCode: string;
    scriptQuestSets: ScriptQuestSets;


    constructor(scriptId?: number, scriptTypeCode?: string, scriptQuestSets?: ScriptQuestSets) {
        this.scriptId = scriptId;
        this.scriptTypeCode = scriptTypeCode;
        this.scriptQuestSets = scriptQuestSets;
    }
}

export class Scripts extends Array<Script> {

    static deserialize(json: any): Scripts {
        let model = null;
        if (json) {
            model = Object.assign(new Scripts(), json);
        }
        return model;
    }

}

export class CorrectAnswer {
    questNum: number;
    subquestNum: number;
    // Note: answerNumeric is BigDecimal in DB and backend that is trimmed to number here.
    // That's why we allow user to enter maximum 12 digits instead of 20
    // Search for '[0-9]{1,12}(\.[0-9]*)?' in the code
    answerNumeric: number;
    constructor(questNum?: number, subquestNum?: number, answerNumeric?: number) {
        this.questNum = questNum;
        this.subquestNum = subquestNum;
        this.answerNumeric = answerNumeric;
    }
}

export class MultiChoice {
    questNum: number;
    choiceNum: number;
    choiceDesc: string;

    constructor(questNum?: number, choiceNum?: number, choiceDesc?: string) {
        this.questNum = questNum;
        this.choiceNum = choiceNum;
        this.choiceDesc = choiceDesc;
    }
}

export class Subquestion {
    questNum: number;
    subquestNum: number;
    subquestDesc: string;

    constructor(questNum?: number, subquestNum?: number, subquestDesc?: string) {
        this.questNum = questNum;
        this.subquestNum = subquestNum;
        this.subquestDesc = subquestDesc;
    }
}

export class PollExtraFields {
    ownerFirstName: string;
    ownerLastName: string;
    createDate: Date;
    ownerAuthorRole: boolean; // whether poll owner has "AUTHOR" role
}

export class EntirePoll {

    btPoll: BtPoll;
    extraFields: PollExtraFields;

    questions: Question[];
    scripts: Script[];
    scriptQuestSets: ScriptQuestSet[];

    correctAnswers: CorrectAnswer[];
    multiChoices: MultiChoice[]; // ordered by questNum and choiceNum
    subquestions: Subquestion[]; // ordered by questNum and subquestNum

    tgroups: number[]; // Taker target groups
    agroups: number[]; // Author groups

    static toJSON(poll) {
        const json = poll;
        return json;
    }

    static deserialize(json: any): EntirePoll {
        let model = null;
        if (json) {
            model = Object.assign(new EntirePoll(), json);
        }
        return model;
    }

    export() {
        return EntirePoll.toJSON(this);
    }

    init(): EntirePoll {
        //this.pollId = 0;
        this.btPoll = new BtPoll().init();
        this.questions = [];
        this.scripts = [];
        this.scriptQuestSets = [];
        this.correctAnswers = [];
        this.multiChoices = [];
        this.subquestions = [];
        this.tgroups = [];
        this.agroups = [];

        return this;
    }
}

export interface PollOwnershipInfo {
    pollId: number;
    title: String;
    ownerId: number;
}

export interface Polls {
    [pollId: number]: PollOwnershipInfo;
}


